import data from "../../shared/sharedData";

export default {
  name: "Employer Point of Contact Information",
  pageInfo: {
    text: "The information contained in this Section must be that of an employee of the employer who is authorized to act on behalf of the employer in labor certification matters. The information in this Section <u>must be different</u> from the agent or attorney information listed in Section E, unless the attorney is an employee of the employer.",
    coloring: "grey",
  },
  sections: [
    {
      name: "Employer Point of Contact Name & Title",
      fields: [
        {
          code: "C.1",
          machine_name: "c1_poc_last",
          widget: "text",
          label: "Contact's Last (family) Name",
          validate: [
            "required",
            // {
            //   minLength: 2,
            //   message: "Contact's full Last Name must contain at least 2 characters.",
            // },
          ],
          maxLength: 35,
          tooltip:
            "Enter the last (family) name of the employer’s point of contact.",
        },
        {
          code: "C.2",
          machine_name: "c2_poc_first",
          widget: "text",
          label: "First (given) Name",
          validate: ["required"],
          maxLength: 35,
          tooltip:
            "Enter the first (given) name of the employer’s point of contact.",
        },
        {
          code: "C.3",
          machine_name: "c3_poc_middle",
          widget: "text",
          label: "Middle name(s)",
          maxLength: 35,
          tooltip: "Enter the middle name of the employer’s point of contact.",
        },
        {
          code: "C.4",
          machine_name: "c4_poc_title",
          widget: "text",
          label: "Contact's Job Title",
          validate: ["required"],
          maxLength: 60,
          tooltip: "Enter the job title of the employer's point of contact.",
        },
      ],
    },
    {
      name: "Employer Point of Contact Address",
      fields: [
        {
          code: "C.5",
          machine_name: "c5_poc_address_1",
          widget: "text",
          label: "Address 1",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Please enter full street address.",
            },
          ],
          maxLength: 60,
          tooltip:
            "Enter the business street address for the employer’s point of contact.",
        },
        {
          code: "C.6",
          machine_name: "c6_poc_address_2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i></span>",
          maxLength: 60,
          tooltip:
            "If additional space is needed for the street address, use this line to complete the street address.",
        },
        {
          code: "C.10",
          machine_name: "c10_poc_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          clearSchema: ["c8_poc_state_id", "c11_poc_province"],
          validate: ["required"],
          tooltip:
            "Enter the country of the employer’s point of contact. If the city and country are the same, the name must still be entered in both fields.",
        },
        {
          code: "C.7",
          machine_name: "c7_poc_city",
          widget: "text",
          label: "City",
          disabled: true,
          disableWhenField: "c10_poc_country_id",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Please enter full City.",
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the city of the employer’s point of contact. If the city and country are the same, the name must still be entered in both fields.",
        },
        {
          code: "C.8",
          machine_name: "c8_poc_state_id",
          widget: "select",
          label: "State",
          selection: data.state,
          state: true,
          disabled: true,
          disableWhenField: "c10_poc_country_id",
          isVisible: {
            when: "c10_poc_country_id",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
          },
          validate: ["required"],
          tooltip: "Enter the state of the employer’s point of contact.",
        },
        {
          code: "C.9",
          machine_name: "c9_poc_zip",
          widget: "text",
          label: "Postal Code",
          disabled: true,
          disableWhenField: "c10_poc_country_id",
          validate: [
            "required",
            {
              postalCountry: "c10_poc_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "c10_poc_country_id",
              },
            },
            {
              isRequired: "c10_poc_country_id",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          maxLength: 10,
          tooltip:
            "Enter the postal (zip) code of the employer’s point of contact.",
        },
        {
          code: "C.11",
          machine_name: "c11_poc_province",
          widget: "text",
          label: "Province",
          disabled: true,
          disableWhenField: "c10_poc_country_id",
          maxLength: 25,
          validate: [
            {
              isRequired: "c10_poc_country_id",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
            {
              minLength: 5,
              message: "Province must contain at least 5 characters.",
            },
          ],
          tooltip:
            "Enter the province of the employer’s point of contact, if applicable.",
        },
      ],
    },
    {
      name: "Employer Point of Contact - Contact Information",
      fields: [
        {
          code: "C.12",
          machine_name: "c12_poc_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          tooltip:
            "Enter the area code and business telephone number of the employer’s point of contact. Include country code, if applicable.",
        },
        {
          code: "C.13",
          machine_name: "c13_poc_phone_ext",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip:
            "Enter the extension of the telephone number of the employer’s point of contact, if applicable.",
        },
        {
          code: "C.14",
          machine_name: "c14_poc_email",
          widget: "text",
          label: "Business e-mail address",
          validate: [
            "required",
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              maxLength: 55,
              message: "This field cannot be more than 55 characters long.",
            },
          ],
          maxLength: 55,
          tooltip: "Enter the business email address, if applicable.",
        },
      ],
    },
  ],
};
